import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { VendorPaymentsPage } from '@/components/VendorPayments/VendorPaymentsPage'
import { listSearchSchema, withoutListDefaults } from '@/components/common/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the shared list page. */
export const Route = createFileRoute('/_app/operations/vendor-payments/')({
  validateSearch: listSearchSchema,
  component: VendorPaymentsRoute,
})

function VendorPaymentsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <VendorPaymentsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
